'use strict';

var jsxRuntime = require('@emotion/react/jsx-runtime');
var Box_web_styles = require('./Box.web.styles.cjs');

/**
 * This component is a styled container that displays content and actions on a single topic
 *
 * {@link https://aviary.supernova-docs.io/latest/components/box/overview-1MhZTGTs | Documentation}
 *
 * @scope Core
 */ const Box = ({ backgroundColor, children, padding = "medium", customCss, ...rest })=>{
    const boxStyles = [
        Box_web_styles.box,
        Box_web_styles.padding[padding],
        backgroundColor && Box_web_styles.backgroundColor[backgroundColor],
        !backgroundColor && Box_web_styles.bordered
    ];
    return /*#__PURE__*/ jsxRuntime.jsx("section", {
        css: [
            boxStyles,
            customCss
        ],
        ...rest,
        children: children
    });
};
Box.displayName = "Box";

exports.Box = Box;
//# sourceMappingURL=Box.web.cjs.map
